import React, { Component } from 'react';

class IconTicketPhone extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" fill="none" viewBox="0 0 24 24">
                <g clipPath="url(#clip0_513_68072)">
                    <path
                        fill="#424242"
                        d="M17.76 24a17.9 17.9 0 01-12.24-5.51C2 14.91-.11 10.2 0 5.87a5.57 5.57 0 011.63-3.8L2.72 1a3.31 3.31 0 015 .35l2 2.65a3.32 3.32 0 01-.3 4.33l-.35.35a1.1 1.1 0 000 1.56l4.68 4.69a1.14 1.14 0 001.56 0l.36-.35a3.32 3.32 0 014.33-.31l2.68 2A3.29 3.29 0 0124 18.69a3.33 3.33 0 01-1 2.59l-1.1 1.1A5.31 5.31 0 0118.5 24h-.74zM5.07 2.21a1.07 1.07 0 00-.78.33l-1.1 1.1a3.31 3.31 0 00-1 2.29 15.59 15.59 0 004.87 11c3.26 3.26 7.48 5.07 11.3 4.85a3.13 3.13 0 002-.95l1.1-1.1a1.11 1.11 0 00-.12-1.67l-2.67-2a1.1 1.1 0 00-1.44.11l-.36.35a3.39 3.39 0 01-4.68 0l-4.69-4.7a3.33 3.33 0 010-4.69l.36-.35A1.13 1.13 0 008 5.33L6 2.65a1.09 1.09 0 00-.8-.44h-.13z"
                    ></path>
                </g>
                <defs>
                    <clipPath id="clip0_513_68072">
                        <path fill="#fff" d="M0 0H24V24H0z"></path>
                    </clipPath>
                </defs>
            </svg>
        );
    }
}

export default IconTicketPhone;